import { AnimatePresence, motion } from "framer-motion"

export default function PaymentVerificationLoader({ sendingOfferLetter, verificationSuccess, titleOne, titleTwo, subhOne, subhTwo }) {
  return (
    <div className="payment-verification-loader">
      <div className="payment-verification-modal-card">
        <AnimatePresence mode="wait">
          {
            verificationSuccess ? (
              <motion.figure initial={{opacity:0}} animate={{opacity:1}} exit={{opacity:0}} >
                <img src="/payver-succ.gif" alt="" />
              </motion.figure>
            ) : (
              <motion.figure initial={{opacity:0}} animate={{opacity:1}} exit={{opacity:0}}  className="payment-ver-blob-fig">
                <div className="blob-overlay"></div>
              </motion.figure>
            )
          }
        </AnimatePresence>

        <AnimatePresence mode="wait">
          {
            sendingOfferLetter ? (
              <motion.h2 key={"heading-pay-ver-1"} initial={{ opacity: 0, y: 4 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -3 }} >{ titleOne || "Sending Your Offer Letter"}</motion.h2>
            ) : (
              <motion.h2 key={"heading-pay-ver-2"} initial={{ opacity: 0, y: 4 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -3 }} >{ titleTwo || "Securely Verifying Your Payment"}</motion.h2>
            )
          }
        </AnimatePresence>

        <AnimatePresence mode="wait">
          {
            sendingOfferLetter ? (
              <motion.p key={"heading-pay-ver-p-1"} initial={{ opacity: 0, y: 4 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -3 }}>{ subhOne || "We are sending you your offer letter. Please do not refresh or close this page"}</motion.p>
            ) : (
              <motion.p key={"heading-pay-ver-p-2"} initial={{ opacity: 0, y: 4 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -3 }}>{ subhTwo || "Getting your account ready. Please do not refresh or close this page."}</motion.p>
            )
          }
        </AnimatePresence>
      </div>
    </div>
  )
}